import React, { useContext } from 'react'
import { FormContext } from '../../views/Connectors/FormContext';

const Textarea = ({ key, label, placeholder, fieldValue, required, id
}) => {
    const { handleChange } = useContext(FormContext)
    return (
        <div className="mb-12 form-group" >
            <label htmlFor={label} className="form-control-label">{placeholder} {required === true ? "*" : ""}</label>
            <textarea className="connector-txtarea" id={label}
                placeholder={placeholder ? placeholder : ''}
                value={fieldValue ? fieldValue : ""}
                required={required}
                onChange={event => handleChange(id, event)}
            />
        </div>
    )
}

export default Textarea